var exports = {
  "n": "x93eb46d8--53eb3b--controls",
};

module.exports = exports;
